export default __webpack_public_path__ + "static/media/womb.e92e79f6.png";